import { render, staticRenderFns } from "./ExercismRobotName.vue?vue&type=template&id=f3a28ed4&"
import script from "./ExercismRobotName.vue?vue&type=script&lang=js&"
export * from "./ExercismRobotName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports